// IE 2026 09 19 / ODOO-5800 (пункт 3 Игоря: «подход с чипсами отчета … фильтрующий на входе формирования выборки отчета —
// должен быть глобальным и для других чипсов в таблице — например для чипса поиска»): МЕСТО ДЕЙСТВИЯ чипса таблицы.
//   chip.meta.place = 'table' | 'input'; значения нет — умолчание вида чипса (как на бэке, be-ie a7577d044):
//   CHIP-Where → input (у списков так было всегда), CHIP-Search → table, CHIP-Metric → table.
//   table — чипс работает по ЗАГРУЖЕННЫМ строкам (отбор, подсветка, ‹ ›); input — бэк режет выборку в select, грид только
//   подсвечивает и ведёт ‹ › (бэк находит запись и по коду / id словаря — свой отбор строк спрятал бы возвращённое намеренно).
// Чистая логика без Vue — общая для AttrChips (форма, значок, перезапрос) и AttrGrid (отбор строк).
import { t } from '@/i18n'   // IE 2026 09 23 / ODOO-341407: i18n
export const CHIP_PLACES = [   // IE 2026 09 23 / ODOO-341407: i18n — подписи геттерами: t() при чтении, после загрузки словаря
    { id: 'table', get title() { return t('Table') }, get hint() { return t('Works on the loaded rows: filter, highlight, navigation') } },
    { id: 'input', get title() { return t('Input') }, get hint() { return t('Restricts the selection on the server: the text is searched in the text and link fields of the selection, the conditions are added to the query') } },
]
export const CHIP_PLACE_SEGMENTS = ['CHIP-Search', 'CHIP-Where']

const raw = (chip) => (chip && chip._raw) || chip || {}

export function chipPlace_default(segment) {
    return segment === 'CHIP-Where' ? 'input' : 'table'
}
// особые запросы поиска бэк на входе не исполняет — они остаются фронтовыми, переключателя у них нет
export function chipPlace_special(title) {
    const t = String(title == null ? '' : title).trim().toLowerCase()
    return t.startsWith('=') || t.startsWith('style:') || t.startsWith('>> ') || t === 'non-empty'
}
export function chipPlace_supported(chip) {
    const c = raw(chip)
    if (!c || !CHIP_PLACE_SEGMENTS.includes(c.segment)) return false
    if (chip._global || chip._mirror || chip._isVirtual || c._isVirtual) return false
    if (c.segment === 'CHIP-Search' && chipPlace_special(c.title)) return false
    return true
}
export function chipPlace_of(chip) {
    const c = raw(chip), p = c.meta && c.meta.place
    return (p === 'input' || p === 'table') ? p : chipPlace_default(c.segment)
}
// чипс действует на входе выборки: поддерживаемый вид, место input, чипс включён
export function chipPlace_isInput(chip) {
    const c = raw(chip)
    return chipPlace_supported(chip) && chipPlace_of(chip) === 'input' && !(c.meta && c.meta.use === false)
}
// записать место: значение по умолчанию в запись не кладём (ключа нет = умолчание — так же читает бэк)
export function chipPlace_write(chip, place) {
    const c = raw(chip)
    if (!c.meta) c.meta = {}
    if (place === chipPlace_default(c.segment)) delete c.meta.place
    else c.meta.place = place
    return chipPlace_of(c)
}
// существо чипса для бэка: у поиска — текст, у фильтра — включённые условия
function essence(c) {
    if (c.segment === 'CHIP-Search') return String(c.title == null ? '' : c.title).trim().replace(/\s+/g, ' ').toLowerCase()
    const strip = (rows) => (rows || []).filter(w => w && w.use !== false).map(w => ({
        l: (w.leftValue && typeof w.leftValue === 'object') ? w.leftValue.value : w.leftValue,
        c: w.condition,
        r: (w.rightValue && typeof w.rightValue === 'object') ? [w.rightValue.value, w.rightValue.valueTo] : w.rightValue,
        a: strip(w.attrs),
    }))
    return JSON.stringify(strip((c.doc && c.doc.WHERE) || []))
}
// отпечаток ВХОДНЫХ чипсов полосы: сменился — выборку надо перечитать (добавление, правка, use, удаление, смена места
// в любую сторону). Пустой поиск и фильтр без условий бэк не исполняет — в отпечаток не идут
export function chipPlace_sig(chips) {
    const out = []
    for (const chip of chips || []) {
        if (!chipPlace_isInput(chip)) continue
        const c = raw(chip), e = essence(c)
        if (!e || e === '[]') continue
        out.push(c.segment + '␟' + e)
    }
    return out.join('␞')
}
// сведения бэка о входном чипсе: record._doc.chips_input [{index, segment, title, place, applied, notes}]
export function chipPlace_info(chips_input, index) {
    if (!Array.isArray(chips_input) || index == null || index < 0) return null
    return chips_input.find(x => x && x.index === index) || null
}
